export const featuresData = [
  {
    icon: 'ri-4k-line',
    title: '超清画质体验',
    desc: '全站支持1080P与4K超清播放，香蕉视频、糖豆视频热门资源均以高码率呈现，画面细腻流畅，给您影院级观影享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '全球CDN加速节点覆盖，小蓝视频、蓝莓视频等平台资源即点即播，告别卡顿与缓冲等待，畅享零延迟观影。',
  },
  {
    icon: 'ri-film-line',
    title: '海量正版片库',
    desc: '汇聚香蕉视频、糖豆视频等平台最新电影电视剧大全，涵盖动作、喜剧、悬疑、爱情等全品类，每日更新不断。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日新鲜上架',
    desc: '编辑团队全天候追踪各平台更新动态，第一时间同步最新上线资源，确保您总能抢先观赏热门内容。',
  },
];

export const aboutData = {
  title: '关于密桃视频',
  content: '密桃视频是国内领先的影视资源聚合平台，专注于整合香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门平台的高清影视内容。我们致力于为广大影迷提供一站式免费在线观影体验，无需注册即可观看全集高清电影和最新电视剧。平台采用先进的分布式内容分发技术，确保每一位用户都能享受不缓冲、零延迟的流畅观影体验。自上线以来，密桃视频凭借海量高清片库和稳定的服务质量，已成为千万用户日常追剧首选平台。',
};

export const contactData = {
  title: '联系我们',
  subtitle: '内容合作 / 问题反馈 / 投稿建议',
  desc: '如果您有优质影视资源推荐、内容合作意向或使用中遇到任何问题，欢迎通过以下方式与我们取得联系。我们重视每一位用户的反馈，并将尽快回复您的诉求。',
};

export const faqData = [
  {
    q: '密桃视频需要注册会员才能观看吗？',
    a: '不需要。密桃视频所有内容完全免费，无需注册登录即可在线观看香蕉视频、糖豆视频、小蓝视频、蓝莓视频等平台的高清全集资源，真正做到即点即看。',
  },
  {
    q: '为什么有些视频加载比较慢？',
    a: '视频加载速度受您的网络环境及源站状态影响。密桃视频采用多线路智能调度技术，会自动为您匹配最优播放线路。如遇加载缓慢，建议切换网络或稍后重试。',
  },
  {
    q: '支持哪些设备观看？',
    a: '密桃视频全面适配PC端、平板电脑和手机端浏览器，无论您使用Windows、macOS、iOS还是Android系统，均可流畅访问并享受高清观影体验。',
  },
  {
    q: '内容更新频率是怎样的？',
    a: '我们的编辑团队全天候监控各平台内容更新，香蕉视频、糖豆视频等主流平台的最新电影和电视剧通常在上线后数小时内即可在密桃视频观看，确保您不错过任何精彩内容。',
  },
];

export const topicsData = [
  { label: '香蕉视频热门', count: '2.8万', href: '#carousel' },
  { label: '糖豆视频新番', count: '1.6万', href: '#carousel' },
  { label: '小蓝视频精选', count: '3.2万', href: '#ranking' },
  { label: '蓝莓视频剧场', count: '2.1万', href: '#media' },
  { label: '悬疑推理', count: '1.4万', href: '#cards' },
  { label: '动作大片', count: '2.5万', href: '#ranking' },
  { label: '浪漫爱情', count: '1.8万', href: '#cards' },
  { label: '科幻巨制', count: '1.2万', href: '#media' },
  { label: '喜剧合集', count: '9.8千', href: '#index' },
];

export const carouselData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%2C%20movie%20poster%20aesthetic%2C%20warm%20golden%20accents%2C%20dark%20cinematic%20background%2C%20professional%20film%20photography%20style%2C%20rich%20color%20grading%2C%20epic%20atmosphere%2C%20widescreen%20composition&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '香蕉视频',
    title: '2026暑期档：十部不可错过的动作巨制',
    desc: '燃爆夏日的精彩打斗场面与震撼特效，让你的假期肾上腺素飙升。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20scene%20with%20warm%20candlelight%2C%20soft%20focus%2C%20elegant%20couple%20silhouette%2C%20emotional%20cinematic%20lighting%2C%20film%20poster%20quality%2C%20tender%20atmosphere%2C%20professional%20movie%20aesthetic&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '糖豆视频',
    title: '糖豆视频爱情剧场：五部高分浪漫电影连播',
    desc: '从青涩暗恋到成熟告白，每一帧都是心动瞬间。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20film%20scene%20with%20mysterious%20shadow%2C%20rainy%20night%20street%2C%20noir%20cinematography%2C%20dramatic%20contrast%20lighting%2C%20film%20noir%20aesthetic%2C%20tense%20mood%2C%20professional%20movie%20photography&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '小蓝视频',
    title: '小蓝视频悬疑季：烧脑反转神作专场',
    desc: '层层反转、结局惊人，每一部都让你猜不到下一秒。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20scene%20with%20futuristic%20cityscape%2C%20neon%20lights%2C%20cyberpunk%20aesthetic%2C%20epic%20scale%2C%20cinematic%20wide%20shot%2C%20professional%20movie%20visual%20effects%2C%20immersive%20sci-fi%20atmosphere&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '蓝莓视频',
    title: '蓝莓视频科幻周：未来世界的无限想象',
    desc: '探索人类与科技的边界，视觉奇观与深度思考并存。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20film%20scene%20with%20bright%20colorful%20lighting%2C%20joyful%20group%20of%20people%20laughing%2C%20warm%20sunny%20setting%2C%20feel-good%20cinematic%20style%2C%20professional%20film%20photography%2C%20happy%20vibrant%20atmosphere&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '精选合集',
    title: '解压必备：十部笑到停不下来的喜剧片',
    desc: '轻松欢乐的高分喜剧，治愈你的一整天。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20film%20scene%20with%20vibrant%20colors%2C%20dynamic%20action%20poses%2C%20Japanese%20animation%20aesthetic%2C%20cinematic%20composition%2C%20epic%20fantasy%20setting%2C%20professional%20anime%20movie%20quality%2C%20dramatic%20lighting&width=600&height=400&seq=carousel-06&orientation=landscape',
    tag: '年度巨献',
    title: '密桃视频独家策划：年度百大佳片巡礼',
    desc: '编辑团队严选全年最佳影视作品，一篇看尽全年精彩。',
  },
];

export const updatesData = [
  { date: '2026-07-31', label: '上新', title: '香蕉视频独家上线《暗夜追凶》全集高清版', href: '#carousel' },
  { date: '2026-07-30', label: '同步', title: '糖豆视频同步更新《春日恋歌》大结局', href: '#carousel' },
  { date: '2026-07-29', label: '热播', title: '小蓝视频悬疑新剧《迷雾深处》播放量破亿', href: '#ranking' },
  { date: '2026-07-28', label: '专题', title: '蓝莓视频「科幻电影周」特别策划上线', href: '#media' },
  { date: '2026-07-27', label: '上新', title: '多平台同步首播《星际迷航：未知领域》', href: '#carousel' },
  { date: '2026-07-26', label: '推荐', title: '编辑精选：本周不可错过的五部高分纪录片', href: '#cards' },
  { date: '2026-07-25', label: '热播', title: '《超能英雄联盟》全系列在香蕉视频完整上线', href: '#ranking' },
  { date: '2026-07-24', label: '同步', title: '糖豆视频日剧频道《东京爱情故事》重制版开播', href: '#media' },
  { date: '2026-07-23', label: '活动', title: '密桃视频暑期观影季：千部大片限时全免', href: '#index' },
];

export const mediaData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20thumbnail%20with%20dramatic%20actor%20portrait%2C%20movie%20poster%20style%2C%20warm%20golden%20lighting%2C%20professional%20film%20photography%2C%20rich%20color%20tone%2C%20artistic%20composition&width=400&height=280&seq=media-01&orientation=landscape',
    title: '暗夜追凶',
    source: '香蕉视频',
    duration: '全12集',
    quality: '4K',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20thumbnail%2C%20couple%20in%20cherry%20blossom%20scene%2C%20soft%20pink%20lighting%2C%20Korean%20drama%20aesthetic%2C%20professional%20cinematography%2C%20tender%20mood%2C%20beautiful%20composition&width=400&height=280&seq=media-02&orientation=landscape',
    title: '春日恋歌',
    source: '糖豆视频',
    duration: '全16集',
    quality: '1080P',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20thumbnail%2C%20foggy%20night%20scene%2C%20detective%20silhouette%2C%20noir%20cinematography%2C%20suspenseful%20mood%2C%20professional%20film%20photography%2C%20dark%20atmospheric%20composition&width=400&height=280&seq=media-03&orientation=landscape',
    title: '迷雾深处',
    source: '小蓝视频',
    duration: '更新至8集',
    quality: '1080P',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20thumbnail%2C%20futuristic%20spaceship%2C%20deep%20space%20background%2C%20cinematic%20visual%20effects%2C%20epic%20scale%2C%20professional%20movie%20poster%20quality%2C%20dramatic%20blue%20lighting&width=400&height=280&seq=media-04&orientation=landscape',
    title: '星际迷航：未知领域',
    source: '蓝莓视频',
    duration: 'HD',
    quality: '4K',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20thumbnail%2C%20colorful%20fantasy%20world%2C%20whimsical%20characters%2C%20vibrant%20art%20style%2C%20studio%20ghibli%20aesthetic%2C%20professional%20animation%20quality%2C%20magical%20atmosphere&width=400&height=280&seq=media-05&orientation=landscape',
    title: '幻境之旅',
    source: '精选动画',
    duration: '电影',
    quality: '1080P',
  },
];

export const rankingData = [
  { rank: 1, title: '暗夜追凶', source: '香蕉视频', heat: 9854321, trend: 'up', tag: '悬疑' },
  { rank: 2, title: '春日恋歌', source: '糖豆视频', heat: 8765432, trend: 'up', tag: '爱情' },
  { rank: 3, title: '超能英雄联盟', source: '香蕉视频', heat: 7654321, trend: 'stable', tag: '动作' },
  { rank: 4, title: '迷雾深处', source: '小蓝视频', heat: 6543210, trend: 'up', tag: '悬疑' },
  { rank: 5, title: '星际迷航：未知领域', source: '蓝莓视频', heat: 5432109, trend: 'new', tag: '科幻' },
];

export const cardsData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20intense%20fight%2C%20urban%20night%20setting%2C%20dramatic%20lighting%2C%20cinematic%20photography%2C%20professional%20film%20quality%2C%20dynamic%20movement%2C%20warm%20color%20grading&width=400&height=260&seq=card-01&orientation=landscape',
    tag: '动作',
    title: '十大经典动作系列全回顾',
    desc: '从《速度与激情》到《疾速追杀》，那些让你肾上腺素飙升的经典瞬间。',
    source: '香蕉视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20film%20scene%2C%20cozy%20coffee%20shop%20setting%2C%20warm%20ambient%20lighting%2C%20candid%20moment%2C%20professional%20cinematography%2C%20feel-good%20aesthetic%2C%20natural%20color%20tone&width=400&height=260&seq=card-02&orientation=landscape',
    tag: '爱情',
    title: '糖豆视频：夏日治愈系爱情片单',
    desc: '适合一个人静静观看的十部温暖爱情电影，每一部都值得收藏。',
    source: '糖豆视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Thriller%20film%20scene%20with%20shadowy%20figure%2C%20rain%20soaked%20street%2C%20noir%20lighting%2C%20suspenseful%20atmosphere%2C%20professional%20film%20photography%2C%20mysterious%20mood%2C%20dark%20cinematic%20style&width=400&height=260&seq=card-03&orientation=landscape',
    tag: '悬疑',
    title: '小蓝视频高分悬疑片精选',
    desc: '结局完全意想不到的神作合集，挑战你的推理极限。',
    source: '小蓝视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20scene%20with%20futuristic%20technology%2C%20holographic%20display%2C%20sleek%20minimalist%20design%2C%20professional%20cinematography%2C%20cool%20color%20palette%2C%20advanced%20civilization%20aesthetic&width=400&height=260&seq=card-04&orientation=landscape',
    tag: '科幻',
    title: '蓝莓视频科幻电影周进行中',
    desc: '从《银翼杀手》到《沙丘》，科幻迷不可错过的经典与新品。',
    source: '蓝莓视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20film%20scene%20with%20bright%20daylight%2C%20funny%20expression%2C%20warm%20colorful%20setting%2C%20professional%20film%20photography%2C%20joyful%20atmosphere%2C%20natural%20lighting%2C%20feel-good%20cinematic%20style&width=400&height=260&seq=card-05&orientation=landscape',
    tag: '喜剧',
    title: '笑到肚子痛的高分喜剧推荐',
    desc: '评分8.5以上的喜剧佳作，拯救每一个不开心的夜晚。',
    source: '精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20scene%20with%20natural%20landscape%2C%20warm%20earth%20tones%2C%20cinematic%20wide%20shot%2C%20professional%20photography%2C%20serene%20atmosphere%2C%20timelapse%20aesthetic%2C%20epic%20nature%20composition&width=400&height=260&seq=card-06&orientation=landscape',
    tag: '纪录',
    title: '五部震撼心灵的纪录电影',
    desc: '用镜头记录真实世界，每一帧都比虚构更动人。',
    source: '精选',
  },
];

export const indexData = [
  { letter: 'A', label: '动作大片', count: 328, href: '#carousel' },
  { letter: 'B', label: '爆笑喜剧', count: 256, href: '#cards' },
  { letter: 'C', label: '超级英雄', count: 187, href: '#ranking' },
  { letter: 'D', label: '动画剧场', count: 214, href: '#media' },
  { letter: 'E', label: '爱情精选', count: 295, href: '#carousel' },
  { letter: 'F', label: '犯罪悬疑', count: 203, href: '#cards' },
  { letter: 'G', label: '古装历史', count: 168, href: '#ranking' },
  { letter: 'H', label: '科幻奇幻', count: 242, href: '#media' },
];

export const appData = {
  title: '移动端观影更便捷',
  subtitle: '随时随地，精彩不停',
  desc: '密桃视频全面适配移动端浏览器，无需下载APP即可在手机上畅享香蕉视频、糖豆视频、小蓝视频、蓝莓视频等平台高清影视资源。横屏竖屏自由切换，流量优化技术让您在移动网络下也能流畅观影。',
  features: ['即点即看无需下载', '流量节省智能优化', '横竖屏自由切换', '全平台浏览器兼容'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20movie%20streaming%20interface%2C%20cinematic%20app%20design%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20setting%2C%20professional%20product%20photography%2C%20clean%20composition%2C%20soft%20background%20with%20warm%20tones&width=600&height=400&seq=app-01&orientation=portrait',
};

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%2C%20clean%20minimalist%20background%2C%20warm%20lighting%2C%20friendly%20expression%2C%20professional%20photography%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '光影追踪者',
    time: '2天前',
    content: '用密桃视频追完了《暗夜追凶》全集，4K画质真的没话说，全程不卡顿。香蕉视频的资源在这里看太方便了，推荐给所有悬疑爱好者！',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20warm%20smile%2C%20professional%20photography%20quality&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '蔷薇与电影',
    time: '3天前',
    content: '糖豆视频的爱情剧资源好全啊，《春日恋歌》大结局在这里第一时间就看完了。感谢密桃视频的编辑团队，更新速度真的没得说。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Asian%20man%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20confident%20expression%2C%20professional%20business%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '银幕流浪者',
    time: '5天前',
    content: '作为重度影迷，密桃视频的资源覆盖真的让我惊喜。小蓝视频和蓝莓视频的冷门佳作在这里都能找到，而且免注册直接看，体验一级棒。',
    rating: 4,
  },
];